import Skeleton from 'react-loading-skeleton'
import { hasAtLeast } from 'remeda'
import { RelatedProductsList } from '@components/CartDrawer/MobileSuggestedProducts/MobileSuggestedProducts.styles'
import { SuggestedHorizontalProduct } from '@components/SuggestedHorizontalProduct/SuggestedHorizontalProduct'
import { SuggestedHorizontalProductSkeleton } from '@components/SuggestedHorizontalProduct/SuggestedHorizontalProductSkeleton'
import { useRelatedProducts } from '@velasca/hooks/use-related-products'
import { SansText } from '@velasca/ui/sans-text'
import { Container } from './styles'

interface NotifySimilarProductsProps {
  title: string
  productHandle: string
  selectedSize: string | undefined
}

export const NotifySimilarProducts = ({
  title,
  productHandle,
  selectedSize,
}: NotifySimilarProductsProps) => {
  const { data, loading, error } = useRelatedProducts({
    type: 'similar',
    productHandle,
  })

  if (!loading && error) {
    return null
  }

  // Filter out products that don't have the user's favourite size available
  const availableSimilarProducts = data?.filter((product) => {
    const { sizes } = product
    const correspondingSize = sizes?.find((size) => size.name === selectedSize)

    return (
      correspondingSize?.quantityAvailable &&
      correspondingSize.quantityAvailable > 0
    )
  })

  // Show only the first three available similar products
  const firstThreeAvailableSimilarProducts = availableSimilarProducts?.slice(
    0,
    3,
  )

  return loading ? (
    <Container>
      <Skeleton />
      <RelatedProductsList>
        {[1, 2, 3].map((e) => (
          <SuggestedHorizontalProductSkeleton key={e} isQuickAdd={false} />
        ))}
      </RelatedProductsList>
    </Container>
  ) : (
    firstThreeAvailableSimilarProducts &&
      hasAtLeast(firstThreeAvailableSimilarProducts, 1) && (
        <Container>
          <SansText
            fontWeight="500"
            color="dark"
            size="md"
            margin="1.5rem 0 1.5rem 0"
          >
            {title}
          </SansText>
          <RelatedProductsList>
            {firstThreeAvailableSimilarProducts?.map(
              ({
                id,
                title: productTitle,
                sizes,
                customProductType,
                isGiftCard,
                productType,
                variants,
              }) => (
                <SuggestedHorizontalProduct
                  isQuickAdd
                  loading={loading}
                  key={id}
                  variant={variants[0]}
                  title={productTitle}
                  productType={productType}
                  sizes={sizes}
                  customProductType={customProductType}
                  isGiftCard={isGiftCard}
                />
              ),
            )}
          </RelatedProductsList>
        </Container>
      )
  )
}
